"use strict";

var React, SingleInputMixin;

React = require("react");

SingleInputMixin = {
  propTypes: {
    data: React.PropTypes.string,
    dataKey: React.PropTypes.string.isRequired,
    rows: React.PropTypes.number
  },
  getDefaultProps: function getDefaultProps() {
    return {
      data: "",
      dataKey: "",
      displayName: ""
    };
  },
  getInitialState: function getInitialState() {
    return {
      data: " " != null ? " " : this.props.data
    };
  },
  submitOnEnter: function submitOnEnter(event) {
    var base;
    if (event.key === "Enter" || event.key === "Return") {
      return typeof (base = this.props).onEnter === "function" ? base.onEnter(event) : void 0;
    }
  }
};

module.exports = SingleInputMixin;


/*****************
 ** WEBPACK FOOTER
 ** ./lib/controls/mixins/SingleInput.js
 ** module id = 286
 ** module chunks = 0
 **/